import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function HowWeDeliverView() {
  useDocumentTitle('How we deliver our care-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-8'}
        title={'How we deliver our care'}
        link={'How we deliver our care'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Working together to make life better
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">A</span>t Quality Health
                  and Home Care Services, our goal is to provide personal and
                  complex care for adults and children. Our committed, reliable,
                  and experienced teams ensure that we consistently deliver a
                  very high-quality, person-centered service to individuals with
                  long-term or life-limiting conditions.
                </p>
                <p className="values_p3 compassion">
                  Our six-step process to creating a care plan that is tailored
                  to meet your individual needs.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/our-values">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/find-a-home">
                        Find a home
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/excellence">
                        Quality and clinical excellence
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">1. Working together</h2>
                <p className="white-color">
                  We are going to hold an initial telephone conversation with
                  you or your family, advocate or other health care professional
                  involved in your care, to enable us to comprehend your
                  specific care needs. After this we will give you more
                  information about our services and discuss how our care
                  service can be shaped to meet your individual clinical,
                  personal and social care needs. We can also give you a
                  quotation if you wish.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">2. Assessing your personal needs</h2>
                <p className="">
                  We will visit your home for free with a registered nurse in
                  order to discuss your care needs in detail as well as fully
                  understand your home setup. We will also carry out a general
                  risk assessment of your home so that we can give you a service
                  proposal that is tailored to meet your specific care needs.
                  Next, we will give you a final quotation for your personal
                  care plan including a detailed breakdown of our service
                  proposal and delivery.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  3. A care plan tailored just for you
                </h2>
                <p className="white-color">
                  When you are ready to proceed, we will conclude your personal
                  care plan which will include the care you will receive, how
                  the care will be given, and most importantly, how you would
                  like your care to be provided. Once you, your family, your
                  advocate, or other healthcare professionals involved in your
                  care are content with your care plan, we will create your
                  personal care team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">4. Your care team</h2>
                <p className="">
                  Our in-house recruitment team will use their expertise to
                  create a care team, by matching our experienced and skilled
                  caregivers with your individual needs. We can also recruit new
                  care staff specifically for your care package, as well as
                  consider and use our existing staff that are already trained
                  in your individual care needs. We will introduce your
                  caregivers to your specific care package and begin the
                  delivery of your service on a date and time you choose.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">5. Training</h2>
                <p className="white-color">
                  Our healthcare assistants and support workers will go through
                  a meet and greet, shadowing, and specialist training to
                  ascertain that they have the skills needed to support the care
                  that is required. Our Registered Nurses will spend time in
                  your home to be sure that staff are fully trained and
                  competent to carry out each clinical task. Note that we
                  provide full Registered Nurse oversight to all care packages
                  that we deliver
                </p>
                <p className="white-color"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">6. Continious support</h2>
                <p className="">
                  Our service doesn't end here. We will contact you regularly
                  for feedback when your care package begins. We will also do
                  quality checks to make sure you continue to receive the
                  highest quality service from our team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default HowWeDeliverView;
